export const topBarHeight = 64;
//export const sideNavWidth = 260;
export const sideNavWidth = 0;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
